import { isDefined as a } from "@perxis-auto/shared";
import { StageId as l } from "@perxis-auto/trade-in-sdk/types";
import { APP as c } from "./app.js";
const A = `${c.name}:events`, n = {
  Initialized: "initialized",
  FormFieldValueChanged: "form_field_value_changed",
  FormFieldFocused: "form_field_focused",
  FormFieldValueReset: "form_field_value_reset",
  ButtonClicked: "button_clicked"
}, E = {
  BACK: "back-button",
  RESET_FORM: "reset-form-button",
  SAVE_RESULT: "save-result-button",
  CALCULATE_COST: "calculate-cost-button",
  FILL_MANUALLY: "fill-manually-button"
}, i = {
  FIELD_VALUE_CHANGED: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "filling"
  },
  FIELD_FOCUSED: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "focusing"
  },
  FILL_MANUALLY: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "click",
    eventLabel: "step1-fill-manually"
  },
  GO_TO_NEXT_STEP: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "click",
    eventLabel: "step1-next"
  },
  GO_TO_PREV_STEP: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "click",
    eventLabel: "step2-back"
  },
  CALCULATE_PRICE: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "click",
    eventLabel: "step2-calc"
  },
  SAVE_RESULT: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "click",
    eventLabel: "step3-save"
  },
  RESET_RESULT: {
    event: "customEvent",
    eventCategory: "avn-tradein",
    eventAction: "click",
    eventLabel: "step3-restart"
  }
}, L = [
  {
    rule: (e, t) => e === n.FormFieldValueChanged && a(t.fieldId),
    analyticEvent: (e) => ({
      ...i.FIELD_VALUE_CHANGED,
      eventLabel: String(e.fieldId)
    })
  },
  {
    rule: (e, t) => e === n.FormFieldFocused && a(t.fieldId),
    analyticEvent: (e) => ({
      ...i.FIELD_FOCUSED,
      eventLabel: String(e.fieldId)
    })
  },
  {
    rule: (e, t) => e === n.ButtonClicked && t.id === E.FILL_MANUALLY,
    analyticEvent: i.FILL_MANUALLY
  },
  {
    rule: (e, t) => e === n.ButtonClicked && t.id === E.BACK,
    analyticEvent: i.GO_TO_PREV_STEP
  },
  {
    rule: (e, t) => e === n.ButtonClicked && t.id === E.CALCULATE_COST && [l.STAGE_3, l.STAGE_4].includes(t.stage),
    analyticEvent: i.CALCULATE_PRICE
  },
  {
    rule: (e, t) => e === n.ButtonClicked && t.id === E.CALCULATE_COST && ![l.STAGE_3, l.STAGE_4].includes(t.stage),
    analyticEvent: i.GO_TO_NEXT_STEP
  },
  {
    rule: (e, t) => e === n.ButtonClicked && t.id === E.SAVE_RESULT,
    analyticEvent: i.SAVE_RESULT
  },
  {
    rule: (e, t) => e === n.ButtonClicked && t.id === E.RESET_FORM,
    analyticEvent: i.RESET_RESULT
  }
];
export {
  L as APP_ANALYTIC_EVENTS,
  n as APP_EVENTS,
  A as APP_EVENTS_CHANNEL,
  E as APP_EVENT_BUTTONS
};
